<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('mobileCode.areaCodeExample')" prop="areaCode" >
        <a-input v-model="form.areaCode" :placeholder="$t('mobileCode.inputAreaCodeExample')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('mobileCode.country')" prop="countryIn" >
        <a-input v-model="form.countryIn" :placeholder="$t('mobileCode.inputCountry')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('mobileCode.countryEn')" prop="countryEn" >
        <a-input v-model="form.countryEn" :placeholder="$t('mobileCode.inputCountryEn')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('mobileCode.countryCn')" prop="countryCn" >
        <a-input v-model="form.countryCn" :placeholder="$t('mobileCode.inputCountryCn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('mobileCode.countryArabic')" prop="country" >
        <a-input v-model="form.country" :placeholder="$t('mobileCode.inputCountryArabic')" />
      </a-form-model-item>

      <!--      <a-form-model-item label="西班牙国家名称" prop="countryBm" >-->
<!--        <a-input v-model="form.countryBm" placeholder="请输入西班牙国家名称" />-->
<!--      </a-form-model-item>-->




      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMobileCode, addMobileCode, updateMobileCode } from '@/api/mobileCode/mobileCode'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        areaCode: null,

        country: null,
        countryEn: null,
        countryCn: null,
        countryBm: null,
        countryIn: null,

        isOpen: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules() {
      return {
        areaCode: [
          {required: true, message: this.$t('mobileCode.areaCodeRequired'), trigger: 'blur'}
        ],
        country: [
          {required: true, message: this.$t('mobileCode.countryRequired'), trigger: 'blur'}
        ],
        countryEn: [
          {required: true, message: this.$t('mobileCode.countryEnRequired'), trigger: 'blur'}
        ],
        countryCn: [
          {required: true, message: this.$t('mobileCode.countryCnRequired'), trigger: 'blur'}
        ],
        countryBm: [
          {required: true, message: this.$t('mobileCode.countryBmRequired'), trigger: 'blur'}
        ],
        countryIn: [
          {required: true, message: this.$t('mobileCode.countryInRequired'), trigger: 'blur'}
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        areaCode: null,
        country: null,
        countryEn: null,
        countryCn: null,
        countryBm: null,
        countryIn: null,
        isOpen: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMobileCode({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateMobileCode(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addMobileCode(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
